import styled from 'astroturf/react';
import { Banner as BannerBase } from 'js/design_system/Banner';
import { useImageAttachment } from './useImageAttachment';
import { usePaperAttachment } from './usePaperAttachment';
import { Image, Paper } from '../types';

export enum AttachmentStatus {
  Empty = 'empty',
  Loading = 'loading',
  Ready = 'ready',
}

export const Banner = styled(BannerBase)`
  margin: 8px 0;
`;

export const LoadingBanner = styled(Banner)`
  font-size: 14px;
  color: $ds-gray-dark;
`;

export function useAttachment(
  initialImage?: Image,
  initialPaper?: Paper,
  removable?: boolean,
) {
  const {
    image,
    status: imageStatus,
    content: imageContent,
    onAttach: onImageAttach,
  } = useImageAttachment(initialImage, removable);
  const {
    paper,
    status: paperStatus,
    content: paperContent,
    onAttach: onPaperAttach,
    onPaperLinksChange,
  } = usePaperAttachment(initialPaper, removable);

  let status = AttachmentStatus.Empty;
  if (imageStatus !== AttachmentStatus.Empty) {
    status = imageStatus;
  } else if (paperStatus !== AttachmentStatus.Empty) {
    status = paperStatus;
  }

  const content = imageContent || paperContent;
  return {
    image,
    paper,
    status,
    content,
    hasAttachment: !!content,
    onImageAttach,
    onPaperAttach,
    onPaperLinksChange,
  };
}
